module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_3.054375c1.png";